module.exports = __webpack_public_path__ + "img/9788949701165.8cc7545f.jpg";